import { Pipe, PipeTransform } from "@angular/core";
import { BitacoraTiposEnum, obtenerNombreBitacoraTipo } from "@shared/enums";

@Pipe({
    name: "nombreBitacoraTipo"
})
export class NombreBitacoraTipoPipe implements PipeTransform {

    transform(tipo: BitacoraTiposEnum): string {
        return obtenerNombreBitacoraTipo(tipo);
    }

}
